import { Alert } from "@mui/material"
import type { FC } from "react"

interface MissingListPriceAlertProps {
  productId: number
}

export const MissingListPriceAlert: FC<MissingListPriceAlertProps> = ({ productId }) => (
  <Alert severity='warning' data-testid={`sales.product-pricing-form.missing-list-price-alert-${productId}`}>
    No list price is available for this configuration. Please contact the product manager to set up pricing.
  </Alert>
)
